module.exports = __webpack_public_path__ + "static/img/asfsafafsafasf.b8df651.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/asfsafafsafasf.png
// module id = M6PN
// module chunks = 2